import React from "react";
import { DynamicFieldStyle1 as InputWithIconAndLabel } from "sites-common/components/DynamicField";
import { Box } from "theme-ui";
import PropTypes from "prop-types";

const DonationByNEFT = ({ compare }) => {
  const [neft, onChange] = compare;
  const { neftBankName, ifscCode, accountNo } = neft;
  return (
    <Box
      sx={{
        mb: "0px !important",
        "& ::placeholder, input, select": {
          fontSize: "1rem!important",
        },
      }}
    >
      <Box
        sx={{
          fontSize: "12px",
          backgroundColor: "background2",
          padding: "7px",
          margin: "0px !important",
        }}
      >
        Please fill the below details, The SMSF Bank details for NEFT/RTGS
        transfer will be emailed to you
      </Box>
      <InputWithIconAndLabel
        value={neftBankName}
        inputTransform={(r) => r.toUpperCase()}
        name="neftBankName"
        variant="border-bottom"
        type="text"
        label="NEFT/RTGS: Bank Name"
        onChange={(e) => onChange(e, "neftBankName")}
      />
      <InputWithIconAndLabel
        value={accountNo}
        variant="border-bottom"
        inputTransform={(r) => r.toUpperCase().trim()}
        name="accountNo"
        type="text"
        label="Bank Account Number"
        onChange={(e) => onChange(e, "accountNo")}
      />
      <InputWithIconAndLabel
        value={ifscCode}
        variant="border-bottom"
        inputTransform={(r) => r.toUpperCase().trim()}
        name="ifscCode"
        type="text"
        label="IFSC Code"
        onChange={(e) => onChange(e, "ifscCode")}
      />
    </Box>
  );
};

DonationByNEFT.propTypes = {
  compare: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({})])
    .isRequired,
};

export default React.memo(DonationByNEFT);
